import React, { Component } from 'react';
import ReactDOM from 'react-dom';

const Section = {
  load: (section) => {
    var container = document.querySelector('.searchkit_autocomplete');
    section.container = document.querySelector('.searchkit_autocomplete');
    if (container != null) {
      Section.set_elasticsearch_autocomplete(section);
    }
  },
  set_elasticsearch_autocomplete(section) {
    ReactDOM.render(<div>My header </div>, section.container);
  }
};

export default Section;
